const prefix = 'fac';
const iconName = 'merge-update';
const width = 515;
const height = 515;
const ligatures = [];
const unicode = null;
const svgPathData = 'M0 68C0 30.4446 30.4446 0 68 0H287C324.555 0 355 30.4446 355 68V287C355 324.555 324.555 355 287 355H68C30.4446 355 0 324.555 0 287V68Z M447 451V515H228V451H447ZM451 447V228C451 225.791 449.209 224 447 224H228C225.791 224 224 225.791 224 228V447C224 449.209 225.791 451 228 451V515C190.738 515 160.476 485.029 160.006 447.879L160 447V228C160 190.445 190.445 160 228 160H447L447.879 160.006C485.029 160.476 515 190.738 515 228V447L514.994 447.879C514.527 484.737 484.737 514.527 447.879 514.994L447 515V451C449.209 451 451 449.209 451 447Z';

export const definition = {
    prefix,
    iconName,
    icon: [
        width,
        height,
        ligatures,
        unicode,
        svgPathData,
    ],
};

export { definition as faMergeUpdate };
